<div class="lead-details-card" [class.expanded]="isExpanded" [class.editing]="isEditing">
  <!-- No action buttons for Location card -->

  <!-- Header with title -->
  <div class="details-header">
    <h3 class="details-title">Location</h3>
  </div>

  <!-- Google Map -->
  @if (getAddress() && getAddress() !== '-') {
    <div class="map-container">
      <app-google-map
        [address]="getAddress()"
        [height]="'200px'"
        [width]="'100%'"
        [zoom]="15">
      </app-google-map>
    </div>
  }
</div>
